import React from "react";
import { Route } from "react-router-dom";
import { DesktopContainer } from "../layouts";
import {
   AddInventory,
   AddressEditor,
   AdminDefaults,
   AdminMaint,
   BillOfLading,
   BOMComponents,
   BOMGlobalUpdate,
   BOMMassReplacement,
   ChangeLabelWeight,
   ConeLookup,
   ConeLookupMobile,
   ConsignedInventoryInquiry,
   ConsignedInventoryUsage,
   ConsignedTransfer,
   CopySpec,
   CorrectiveActionSearch,
   CountMain,
   CountNew,
   CountScan,
   CreateCoA,
   CreateItemCode,
   DevTest,
   PrintMachineLabels,
   // Cost quoting moved to Focus - DISABLED 2026-07-30 (see the routes below)
   //CostQuote,
   //CostQuoteLookup,
   CreateMachinePartCode,
   CreateNewProductionItem,
   CreateNewSampleItem,
   CustomerCard,
   CustomerDashboard,
   CustomerMachinePartPricing,
   CustomerMachinePartPricingMaintenance,
   DashboardAdmin,
   EditQualityTest,
   EmployeeAttendanceReport,
   EngineerTools,
   EnterQualityTestData,
   EventViewer,
   ExplodeCase,
   InventoryCountPosting,
   InventoryDashboard,
   InventoryLabels,
   InventoryStockStatus,
   InventoryTrackingTools,
   InvoiceAndPackingList,
   InvoiceSettings,
   ItemBomLookup,
   ItemClassMaintenance,
   ItemLookup,
   ItemPriceReport,
   ItemSpliceReqs,
   LandedCostSearch,
   LateShipment,
   MachineManagement,
   MachineWorkOrderProcessing,
   MobileRepairs,
   MobileRwoCreate,
   MobileRwoEdit,
   MobileRwoNew,
   MobileRwoScan,
   MostSold,
   MoveIVLabelToNewSite,
   MoveOrder,
   MoveOrders,
   NegativeInventory,
   NewProductionRecord,
   NoBomPoPlanning,
   OrderPlacement,
   OrdersOnHold,
   PalletLabels,
   PartsManager,
   PMCheck,
   PMItemPriceHistory,
   POReport,
   PrintConeLabels,
   PrinterSettings,
   PriorityItems,
   ProcessChanges,
   ProcessChangeEdit,
   ProcessInvoices,
   ProductionPMNeeds,
   ProductionSearch,
   PurchaseOrderPlanning,
   QCHold,
   QrCodeLookup,
   RawMaterialUsage,
   ReceivingLabelManager,
   RepairWorkOrder,
   RepairWorkOrderSearch,
   AutomationHealth,
   ReportPreview,
   ResetCaseStatus,
   RoleManager,
   SalesCallTracking,
   SalesCallTrackingEdit,
   SalesDashboard,
   SalesFulfillment,
   SalesReport,
   ScanProduction,
   ShippingLookup,
   ShippingSchedule,
   SiteOrdersForItem,
   SupplierPerformanceScorecard,
   TareCheck,
   ThreadFinder,
   TopVendors,
   TransferEdit,
   Transfers,
   UpsAccountEditor,
   User,
   Users,
   VendorDashboard,
   VendorInvoiceSummary,
   VendorItemRequest,
   VendorItemScan,
   WhereUsed,
   WorkOrderDetail,
} from "../components";
import {
   PlanningSchedule,
   PPHCalculator,
   ProductionPlanning,
   ProductionPlanningForSpecifiedItem,
   ProductionReports,
   ProductionWorkOrders,
} from "../components/ProductionModule/index";
import { constants } from ".";
import {
   CorrectiveActionEdit,
   InternalCorrectiveEdit,
   PreventativeActionEdit,
   SupplierActionEdit,
} from "../components/CorrectiveActionEditScreens";
import { QualityContainer } from "../components/SpecEditComponents/index";
import { MachineSetupContainer } from "../components/MachineSetupComponents/index";

const { ENDPOINTS } = constants;

const routeLists = [
   // Admin Routes
   <Route exact key="/admin/menu" path="/admin/menu" element={<DashboardAdmin />} />,
   <Route exact key="/admin/events" path="/admin/events" element={<EventViewer />} />,
   <Route exact key="/admin/automation-health" path="/admin/automation-health" element={<AutomationHealth />} />,
   <Route exact key="/admin/report-preview" path="/admin/report-preview" element={<ReportPreview />} />,
   <Route exact key="/admin/reset-case" path="/admin/reset-case" element={<ResetCaseStatus />} />,
   <Route exact key="/admin/roles" path="/admin/roles" element={<RoleManager />} />,
   <Route exact key="/admin/users" path="/admin/users" element={<Users />} />,
   <Route exact key="/admin/users/id" path="/admin/users/:id" element={<User />} />,
   <Route exact key="/admin/maint" path="/admin/maint" element={<AdminMaint />} />,
   <Route exact key="/admin/defaults" path="/admin/defaults" element={<AdminDefaults />} />,

   // Developer Routes - admin role will have access too
   <Route exact key={ENDPOINTS.qrCodeLookup} path={ENDPOINTS.qrCodeLookup} element={<QrCodeLookup />} />,
   <Route exact key={ENDPOINTS.devTest} path={ENDPOINTS.devTest} element={<DevTest />} />,

   // Customer Service Routes
   <Route exact key={ENDPOINTS.consignedInventory} path={ENDPOINTS.consignedInventory} element={<ConsignedInventoryInquiry />} />,
   <Route exact key={ENDPOINTS.consignedInventoryUsage} path={ENDPOINTS.consignedInventoryUsage} element={<ConsignedInventoryUsage />} />,
   <Route exact key={ENDPOINTS.customerCard} path={ENDPOINTS.customerCard} element={<CustomerCard />} />,
   <Route exact key={ENDPOINTS.customerDashboard} path={ENDPOINTS.customerDashboard} element={<CustomerDashboard />} />,
   <Route exact key={ENDPOINTS.customerDashboardParam} path={ENDPOINTS.customerDashboardParam} element={<CustomerDashboard />} />,
   <Route exact key={ENDPOINTS.customerMachinePartsPricing} path={ENDPOINTS.customerMachinePartsPricing}
      element={<CustomerMachinePartPricing />} />,
   <Route exact key={ENDPOINTS.customerMachinePartsPricingParam} path={ENDPOINTS.customerMachinePartsPricingParam}
      element={<CustomerMachinePartPricing />} />,
   <Route exact key={ENDPOINTS.invoices} path={ENDPOINTS.invoices} element={<InvoiceAndPackingList />} />,
   <Route exact key={ENDPOINTS.orderHold} path={ENDPOINTS.orderHold} element={<OrdersOnHold />} />,
   <Route exact key={ENDPOINTS.processInvoices} path={ENDPOINTS.processInvoices} element={<ProcessInvoices />} />,

   // Engineering Routes
   <Route exact key={ENDPOINTS.bomComponents} path={ENDPOINTS.bomComponents} element={<BOMComponents />} />,
   <Route exact key={ENDPOINTS.bomComponentsParam} path={ENDPOINTS.bomComponentsParam} element={<BOMComponents />} />,
   <Route exact key={ENDPOINTS.bomComponentsUseParams} path={ENDPOINTS.bomComponentsUseParams} element={<BOMComponents />} />,
   <Route exact key={ENDPOINTS.createItemCode} path={ENDPOINTS.createItemCode} element={<CreateItemCode />} />,
   <Route exact key={ENDPOINTS.createProductionItem} path={ENDPOINTS.createProductionItem + "/:routeId"}
      element={<CreateNewProductionItem />} />,
   <Route exact key={ENDPOINTS.createSampleItem} path={ENDPOINTS.createSampleItem + "/:routeId"}
      element={<CreateNewSampleItem />} />,
   <Route exact key={ENDPOINTS.globalBOMUpdate} path={ENDPOINTS.globalBOMUpdate} element={<BOMGlobalUpdate />} />,
   <Route exact key={ENDPOINTS.itemClassMaintenance} path={ENDPOINTS.itemClassMaintenance}
      element={<ItemClassMaintenance />} />,
   <Route exact key={ENDPOINTS.machineLabels} path={ENDPOINTS.machineLabels} element={<PrintMachineLabels />} />,
   <Route exact key={ENDPOINTS.machineManagement} path={ENDPOINTS.machineManagement} element={<MachineManagement />} />,
   <Route exact key={ENDPOINTS.machineSetups} path={ENDPOINTS.machineSetups} element={<MachineSetupContainer />} />,
   <Route exact key={ENDPOINTS.machineSetupsParam} path={ENDPOINTS.machineSetupsParam} element={<MachineSetupContainer />} />,
   <Route exact key={ENDPOINTS.massUpdateBOMLineItem} path={ENDPOINTS.massUpdateBOMLineItem}
      element={<BOMMassReplacement />} />,
   <Route exact key={ENDPOINTS.processChanges} path={ENDPOINTS.processChanges} element={<ProcessChanges />} />,
   <Route exact key={ENDPOINTS.processChangeEdit} path={`${ENDPOINTS.processChangeEdit}/:routePCRId`}
      element={<ProcessChangeEdit />} />,
   <Route exact key={ENDPOINTS.spliceReqs} path={ENDPOINTS.spliceReqs} element={<ItemSpliceReqs />} />,
   <Route exact key={ENDPOINTS.tareChecks} path={ENDPOINTS.tareChecks} element={<TareCheck />} />,
   <Route exact key={ENDPOINTS.engTools} path={ENDPOINTS.engTools} element={<EngineerTools />} />,

   //HR Routes
   <Route exact key={ENDPOINTS.employeeAttendanceReport} path={ENDPOINTS.employeeAttendanceReport} element={<EmployeeAttendanceReport />} />,

   // Inventory Routes
   <Route exact key={ENDPOINTS.inventoryCountPosting} path={ENDPOINTS.inventoryCountPosting} element={<InventoryCountPosting />} />,
   <Route exact key={ENDPOINTS.inventoryDashboard} path={ENDPOINTS.inventoryDashboard} element={<InventoryDashboard />} />,
   <Route exact key={ENDPOINTS.inventoryDashboardParam} path={ENDPOINTS.inventoryDashboardParam} element={<InventoryDashboard />} />,
   <Route exact key={ENDPOINTS.inventoryStockStatus} path={ENDPOINTS.inventoryStockStatus} element={<InventoryStockStatus />} />,
   <Route exact key={ENDPOINTS.negativeInventory} path={ENDPOINTS.negativeInventory} element={<NegativeInventory />} />,
   <Route exact key={ENDPOINTS.whereUsed} path={ENDPOINTS.whereUsed} element={<WhereUsed />} />,
   <Route exact key={ENDPOINTS.itemSiteOrders} path={`${ENDPOINTS.itemSiteOrders}/:itemNum/:siteId`} element={<SiteOrdersForItem />} />,

   // Maintenance Routes
   <Route exact key={ENDPOINTS.repairWorkOrder} path={`${ENDPOINTS.repairWorkOrder}/:id`} element={<RepairWorkOrder />} />,
   <Route exact key={ENDPOINTS.rwoSearch} path={ENDPOINTS.rwoSearch} element={<RepairWorkOrderSearch />} />,

   // Misc Routes
   <Route exact key={ENDPOINTS.addressEditor} path={`${ENDPOINTS.addressEditor}/:context/:id`} element={<AddressEditor />} />,
   <Route exact key={ENDPOINTS.billOfLading} path={`${ENDPOINTS.billOfLading}/:id`} element={<BillOfLading />} />,
   <Route exact key={ENDPOINTS.invoiceSettings} path={ENDPOINTS.invoiceSettings} element={<InvoiceSettings />} />,
   <Route exact key={ENDPOINTS.order} path={ENDPOINTS.order} element={<OrderPlacement />} />,
   <Route exact key={ENDPOINTS.upsEditor} path={`${ENDPOINTS.upsEditor}/:id`} element={<UpsAccountEditor />} />,

   // Mobile Routes
   <Route exact key={ENDPOINTS.addInventory} path={ENDPOINTS.addInventory} element={<AddInventory />} />,
   <Route exact key={ENDPOINTS.coneLookupMobile} path={ENDPOINTS.coneLookupMobile} element={<ConeLookupMobile />} />,
   <Route exact key={ENDPOINTS.consignedTransfer} path={ENDPOINTS.consignedTransfer} element={<ConsignedTransfer />} />,
   <Route exact key={ENDPOINTS.countScan} path={`${ENDPOINTS.countScan}/:id`} element={<CountScan />} />,
   <Route exact key={ENDPOINTS.countSearch} path={ENDPOINTS.countSearch} element={<CountMain />} />,
   <Route exact key={ENDPOINTS.createCount} path={ENDPOINTS.createCount} element={<CountNew />} />,
   <Route exact key={ENDPOINTS.itemLookup} path={ENDPOINTS.itemLookup} element={<ItemLookup />} />,
   <Route exact key={ENDPOINTS.labelWeight} path={ENDPOINTS.labelWeight} element={<ChangeLabelWeight />} />,
   <Route exact key={ENDPOINTS.mobileBomLookup} path={ENDPOINTS.mobileBomLookup} element={<ItemBomLookup />} />,
   <Route exact key={ENDPOINTS.mobileRwoCreate} path={`${ENDPOINTS.mobileRwoCreate}`} element={<MobileRwoCreate />} />,
   <Route exact key={ENDPOINTS.mobileRwoEdit} path={`${ENDPOINTS.mobileRwoEdit}/:id`} element={<MobileRwoEdit />} />,
   <Route exact key={ENDPOINTS.mobileRwoNew} path={`${ENDPOINTS.mobileRwoNew}/:id`} element={<MobileRwoNew />} />,
   <Route exact key={ENDPOINTS.mobileRwoScan} path={`${ENDPOINTS.mobileRwoScan}/:id`} element={<MobileRwoScan />} />,
   <Route exact key={ENDPOINTS.mobileRwoSearch} path={ENDPOINTS.mobileRwoSearch} element={<MobileRepairs />} />,
   <Route exact key={ENDPOINTS.moveOrder} path={`${ENDPOINTS.moveOrder}/:id`} element={<MoveOrder />} />,
   <Route exact key={ENDPOINTS.moveOrders} path={ENDPOINTS.moveOrders} element={<MoveOrders />} />,
   <Route exact key={ENDPOINTS.newProdRecord} path={ENDPOINTS.newProdRecord} element={<NewProductionRecord />} />,
   <Route exact key={ENDPOINTS.printerDefaults} path={ENDPOINTS.printerDefaults} element={<PrinterSettings />} />,
   <Route exact key={ENDPOINTS.purchaseMaterialCheck} path={ENDPOINTS.purchaseMaterialCheck} element={<PMCheck />} />,
   <Route exact key={ENDPOINTS.salesFulfillment} path={ENDPOINTS.salesFulfillment} element={<SalesFulfillment />} />,
   <Route exact key={ENDPOINTS.scanProduction} path={ENDPOINTS.scanProduction} element={<ScanProduction />} />,
   <Route exact key={ENDPOINTS.transfer} path={`${ENDPOINTS.transfer}/:id`} element={<TransferEdit />} />,
   <Route exact key={ENDPOINTS.transfers} path={ENDPOINTS.transfers} element={<Transfers />} />,
   <Route exact key={ENDPOINTS.vendorItemScan} path={ENDPOINTS.vendorItemScan} element={<VendorItemScan />} />,

   // Production Routes
   <Route exact key={ENDPOINTS.coneRecordSearch} path={ENDPOINTS.coneRecordSearch} element={<ProductionSearch />} />,
   <Route exact key={ENDPOINTS.planningSchedule} path={ENDPOINTS.planningSchedule} element={<PlanningSchedule />} />,
   <Route exact key={ENDPOINTS.pphCalculator} path={ENDPOINTS.pphCalculator} element={<PPHCalculator />} />,
   <Route exact key={ENDPOINTS.pphCalculatorParam} path={ENDPOINTS.pphCalculatorParam} element={<PPHCalculator />} />,
   <Route exact key={ENDPOINTS.printConeLabels} path={ENDPOINTS.printConeLabels} element={<PrintConeLabels />} />,
   <Route exact key={ENDPOINTS.coneLookup} path={ENDPOINTS.coneLookup} element={<ConeLookup />} />,
   <Route exact key={ENDPOINTS.productionPlanning} path={ENDPOINTS.productionPlanning} element={<ProductionPlanning />} />,
   <Route exact key={ENDPOINTS.productionPlanningForSpecifiedItem}
      path={`${ENDPOINTS.productionPlanningForSpecifiedItem}/:itemNumber`}
      element={<ProductionPlanningForSpecifiedItem />} />,
   <Route exact key={ENDPOINTS.productionReports} path={ENDPOINTS.productionReports} element={<ProductionReports />} />,
   <Route exact key={ENDPOINTS.productionWorkOrders} path={ENDPOINTS.productionWorkOrders} element={<ProductionWorkOrders />} />,

   // Purchasing Routes
   <Route exact key={ENDPOINTS.landedSearch} path={ENDPOINTS.landedSearch} element={<LandedCostSearch />} />,
   <Route exact key={ENDPOINTS.noBomPlanning} path={ENDPOINTS.noBomPlanning} element={<NoBomPoPlanning />} />,
   <Route exact key={ENDPOINTS.poReport} path={ENDPOINTS.poReport} element={<POReport />} />,
   <Route exact key={ENDPOINTS.priorityItems} path={ENDPOINTS.priorityItems} element={<PriorityItems />} />,
   <Route exact key={ENDPOINTS.productionPmNeeds} path={ENDPOINTS.productionPmNeeds} element={<ProductionPMNeeds />} />,
   <Route exact key={ENDPOINTS.purchaseOrderPlanning} path={ENDPOINTS.purchaseOrderPlanning} element={<PurchaseOrderPlanning />} />,
   <Route exact key={ENDPOINTS.purchasePriceHistory} path={ENDPOINTS.purchasePriceHistory} element={<PMItemPriceHistory />} />,
   <Route exact key={ENDPOINTS.purchasePriceHistoryUseParams} path={ENDPOINTS.purchasePriceHistoryUseParams} element={<PMItemPriceHistory />} />,
   <Route exact key={ENDPOINTS.rawMaterialUsage} path={ENDPOINTS.rawMaterialUsage} element={<RawMaterialUsage />} />,
   <Route exact key={ENDPOINTS.supplierPerformance} path={ENDPOINTS.supplierPerformance} element={<SupplierPerformanceScorecard />} />,
   <Route exact key={ENDPOINTS.topVendors} path={ENDPOINTS.topVendors} element={<TopVendors />} />,
   <Route exact key={ENDPOINTS.vendorDashboard} path={ENDPOINTS.vendorDashboard} element={<VendorDashboard />} />,
   <Route exact key={ENDPOINTS.vendorDashboardParam} path={ENDPOINTS.vendorDashboardParam} element={<VendorDashboard />} />,
   <Route exact key={ENDPOINTS.vendorInvoices} path={ENDPOINTS.vendorInvoices} element={<VendorInvoiceSummary />} />,
   <Route exact key={ENDPOINTS.vendorItemRqst} path={ENDPOINTS.vendorItemRqst} element={<VendorItemRequest />} />,

   //Quality Routes
   <Route exact key={ENDPOINTS.copySpec} path={ENDPOINTS.copySpec} element={<CopySpec />} />,
   <Route exact key={ENDPOINTS.correctiveActionEdit} path={`${ENDPOINTS.correctiveActionEdit}/:actionId`}
      element={<CorrectiveActionEdit />} />,
   <Route exact key={ENDPOINTS.correctiveActionPreventativeEdit} path={`${ENDPOINTS.correctiveActionPreventativeEdit}/:actionId`}
      element={<PreventativeActionEdit />} />,
   <Route exact key={ENDPOINTS.correctiveActionSearch} path={ENDPOINTS.correctiveActionSearch} element={<CorrectiveActionSearch />} />,
   <Route exact key={ENDPOINTS.correctiveActionSupplierEdit} path={`${ENDPOINTS.correctiveActionSupplierEdit}/:actionId`}
      element={<SupplierActionEdit />} />,
   <Route exact key={ENDPOINTS.correctiveInternalActionEdit} path={`${ENDPOINTS.correctiveInternalActionEdit}/:actionId`}
      element={<InternalCorrectiveEdit />} />,
   <Route exact key={ENDPOINTS.createCoA} path={ENDPOINTS.createCoA} element={<CreateCoA />} />,
   <Route exact key={ENDPOINTS.createCoAParams} path={ENDPOINTS.createCoAParams} element={<CreateCoA />} />,
   <Route exact key={ENDPOINTS.editTestItem} path={`${ENDPOINTS.editTestItem}`} element={<EditQualityTest />} />,
   <Route exact key={ENDPOINTS.enterQualityTestData} path={ENDPOINTS.enterQualityTestData} element={<EnterQualityTestData />} />,
   <Route exact key={ENDPOINTS.inventoryTrackingTools} path={ENDPOINTS.inventoryTrackingTools} element={<InventoryTrackingTools />} />,
   <Route exact key={ENDPOINTS.qcHold} path={ENDPOINTS.qcHold} element={<QCHold />} />,
   <Route exact key={ENDPOINTS.qualitySpecifications} path={ENDPOINTS.qualitySpecifications} element={<QualityContainer />} />,
   <Route exact key={ENDPOINTS.qualitySpecificationsParam} path={ENDPOINTS.qualitySpecificationsParam} element={<QualityContainer />} />,
   <Route exact key={ENDPOINTS.workOrderDetail} path={`${ENDPOINTS.workOrderDetail}/:workOrderId`} element={<WorkOrderDetail />} />,

   // Sales Routes
   <Route exact key={ENDPOINTS.itemPriceReport} path={ENDPOINTS.itemPriceReport} element={<ItemPriceReport />} />,
   <Route exact key={ENDPOINTS.lateShipment} path={ENDPOINTS.lateShipment} element={<LateShipment />} />,
   // MostSold carries no DesktopContainer of its own because SalesReport embeds it inside one; on its own route
   // it needs the wrapper, or a pinned sidebar covers the page's left edge.
   <Route exact key={ENDPOINTS.mostSold} path={ENDPOINTS.mostSold} element={<DesktopContainer screenName="Most Sold"><MostSold /></DesktopContainer>} />,
   <Route exact key={ENDPOINTS.salesDashboard} path={ENDPOINTS.salesDashboard} element={<SalesDashboard />} />,
   <Route exact key={ENDPOINTS.salesReport} path={ENDPOINTS.salesReport} element={<SalesReport />} />,
   // DISABLED 2026-07-30 per Jay: cost quoting moved to the Focus site. Commented out rather than
   // deleted until we are certain it is not wanted here again. With no route, an old bookmark to
   // /cost-quote or /quote-lookup falls through to the App.js "/*" catch-all and lands on Home - no
   // 404 and no error toast. The screens themselves (CostQuote.js, CostQuoteLookup.js) are left in
   // place, still exported from the component barrel.
   //<Route exact key={ENDPOINTS.costQuote} path={ENDPOINTS.costQuote} element={<CostQuote />} />,
   //<Route exact key={ENDPOINTS.costQuoteEdit} path={`${ENDPOINTS.costQuote}/:id`} element={<CostQuote />} />,
   //<Route exact key={ENDPOINTS.costQuoteLookup} path={ENDPOINTS.costQuoteLookup} element={<CostQuoteLookup />} />,

   // Sewing Tech Routes
   <Route exact key={ENDPOINTS.createMachinePartCode} path={ENDPOINTS.createMachinePartCode} element={<CreateMachinePartCode />} />,
   <Route exact key={ENDPOINTS.customerMachinePartsPricingParam} path={ENDPOINTS.customerMachinePartsPricingParam}
      element={<CustomerMachinePartPricing />} />,
   <Route exact key={ENDPOINTS.machineWorkorderProcessing} path={ENDPOINTS.machineWorkorderProcessing}
      element={<MachineWorkOrderProcessing />} />,
   <Route exact key={ENDPOINTS.machinePartPricingMaintenance} path={ENDPOINTS.machinePartPricingMaintenance}
      element={<CustomerMachinePartPricingMaintenance />} />,
   <Route exact key={ENDPOINTS.partsManager} path={ENDPOINTS.partsManager} element={<PartsManager />} />,
   <Route exact key={ENDPOINTS.salesCallTracking} path={ENDPOINTS.salesCallTracking} element={<SalesCallTracking />} />,
   <Route exact key={ENDPOINTS.salesCallTrackingEdit} path={`${ENDPOINTS.salesCallTrackingEdit}/:trackingId`}
      element={<SalesCallTrackingEdit />} />,
   <Route exact key={ENDPOINTS.threadFinder} path={ENDPOINTS.threadFinder} element={<ThreadFinder />} />,

   // Warehouse Routes
   <Route exact key={ENDPOINTS.explodeCase} path={ENDPOINTS.explodeCase} element={<ExplodeCase />} />,
   <Route exact key={ENDPOINTS.inventoryLabels} path={ENDPOINTS.inventoryLabels} element={<InventoryLabels />} />,
   <Route exact key={ENDPOINTS.moveIVLabelToNewSite} path={ENDPOINTS.moveIVLabelToNewSite} element={<MoveIVLabelToNewSite />} />,
   <Route exact key={ENDPOINTS.palletLabels} path={ENDPOINTS.palletLabels} element={<PalletLabels />} />,
   <Route exact key={ENDPOINTS.receivingLabelManager} path={ENDPOINTS.receivingLabelManager} element={<ReceivingLabelManager />} />,
   <Route exact key={ENDPOINTS.shippingLookup} path={ENDPOINTS.shippingLookup} element={<ShippingLookup />} />,
   <Route exact key={ENDPOINTS.shippingSchedule} path={ENDPOINTS.shippingSchedule} element={<ShippingSchedule />} />,
];

export default routeLists;
